import { DEFAULT_CONTROL_PORT, DEFAULT_HOST } from "./consts";

export interface BaseAddressOptions {
  host?: string;
  /**
   * Pass `null` to omit the port entirely.
   *
   * Needed for same-origin gateway URLs: in direct ARC mode everything is
   * reached through `http://<gateway-origin>/api/...` on the default port, so
   * emitting `:9090` would point at a listener the browser must not use.
   * `undefined` still falls back to the default port, so existing callers and
   * fleet mode are unaffected.
   */
  port?: number | null;
  subpath?: string;
}

export interface AddressOptions extends BaseAddressOptions {
  protocol?: string;
}

export const address = ({
  protocol = "",
  host = DEFAULT_HOST,
  port = DEFAULT_CONTROL_PORT,
  subpath = "",
}: AddressOptions) => {
  subpath = (subpath || "").replace(/^\/+/, "");
  subpath = subpath && `/${subpath}`;
  protocol = protocol ? `${protocol}//` : "";
  // `port: null` omits the port; `undefined` keeps the default above.
  const portPart = port == null ? "" : `:${port}`;
  return `${protocol}${host}${portPart}${subpath}`;
};

export interface HTTPAdressOptions extends BaseAddressOptions {
  useSSL?: boolean;
  token?: string;
}

export const httpAddress = ({
  useSSL = true,
  host = DEFAULT_HOST,
  port = DEFAULT_CONTROL_PORT,
  subpath = "",
}: HTTPAdressOptions) =>
  address({ protocol: useSSL ? "https:" : "http:", host, port, subpath });

export const wsAddress = ({
  useSSL = true,
  host = DEFAULT_HOST,
  port = DEFAULT_CONTROL_PORT,
  subpath = "",
  token,
}: HTTPAdressOptions) => {
  const protocol = useSSL ? "wss:" : "ws:";
  const base = address({ protocol, host, port, subpath });
  return token ? `${base}?token=${encodeURIComponent(token)}` : base;
};
